var _path, _path2, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.999 2.58301C20.3041 2.58318 25.415 7.69486 25.415 14C25.4149 17.3325 23.9878 20.3315 21.71 22.4189L21.4863 22.6182C19.4818 24.3612 16.8639 25.4159 13.999 25.416C11.3128 25.416 8.84349 24.4889 6.89355 22.9365L6.51074 22.6182C4.10339 20.5247 2.58213 17.4401 2.58203 14C2.58203 7.69475 7.69377 2.58301 13.999 2.58301Z",
    fill: "url(#paint0_linear_7132_94079)",
    stroke: "url(#paint1_linear_7132_94079)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 16C16.8038 16.0001 19.2766 17.4131 20.747 19.5655C21.2014 20.2307 21.0638 21.1225 20.4483 21.6424C18.7075 23.1131 16.4577 24 14.0004 24C11.5425 24 9.2923 23.1127 7.55129 21.6416C6.93595 21.1216 6.79839 20.2298 7.25294 19.5646C8.72363 17.4125 11.1971 16 14.0004 16Z",
    fill: "#2F2F2F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 11.5,
    r: 3.5,
    fill: "#2F2F2F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7132_94079",
    x1: 13.9987,
    y1: 2.33301,
    x2: 13.9987,
    y2: 25.6663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7132_94079",
    x1: 13.9987,
    y1: 2.33301,
    x2: 13.9987,
    y2: 25.6663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic-user.acb9f74f5feaa5b62234023294700beb.svg";
export { ForwardRef as ReactComponent };